module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marjorie Tallman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Marjorie Tallman has written several subject dictionaries including "), _c('I', [_vm._v("Dictionary of American Folklore")]), _vm._v(", "), _c('I', [_vm._v("Dictionary of Civics and Government")]), _vm._v(", and "), _c('I', [_vm._v("Dictionary of American Government.")]), _c('BR'), _vm._v("  ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FDg4MB/tc-custom/9781504055062.jpg?1700849459938",
      "alt": "This image is the cover for the book Dictionary of American Folklore"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dictionary of American Folklore\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Discover the delightful tales, characters, and themes of classic American storytelling in this comprehensive "), _c('i', [_vm._v("Dictionary of American Folklore")]), _vm._v(". Ever wonder the origins of the fairy tales, myths, and legends passed down from generation to generation throughout America’s long history? From Paul Bunyan to Johnny Appleseed, Marjorie Tallman covers it all in an engaging voice sure to please readers of all ages."), _c('br')]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0